// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2GHvx","info":"UpdateTermsInfo_info__kQEFE"};